<template>
  <div style="height: 100%;width: 100%;overflow: auto">
    <el-form ref="formData" :model="busData" label-width="150px" :rules="rules" style="margin: 20px" >
      <div v-if="busData.button_id === 'addDept'">
        <el-col :span="22">
          <el-form-item label="父部门:" prop="parent_name">
            <el-input v-model="busData.parent_name" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="部门名称:" prop="name" required>
            <el-input v-model="busData.name" placeholder="请填写部门名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="部门类型:" prop="type">
            <el-select v-model="busData.type" placeholder="请选择部门类型">
              <el-option v-for="item in typeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="部门权限" prop="role_ids">
            <el-select v-model="busData.role_ids" placeholder="请选择部门权限" multiple>
              <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <div style="text-align: center;">
          <el-button size="default" type="primary" @click="addDepartment()">创建</el-button>
        </div>
      </div>
      <div v-if="busData.button_id === 'editDept'">
        <el-col :span="22" v-if="busData.id === 'ROOT'">
          <el-form-item label="公司名称:" prop="name" required>
            <el-select v-model="busData.name" placeholder="请选择公司名称">
              <el-option v-for="item in companyList" :key="item.name" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22" v-if="busData.id !== 'ROOT'">
          <el-form-item label="部门名称:" prop="name" required>
            <el-input v-model="busData.name" placeholder="请填写部门名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="部门类型:" prop="type">
            <el-select v-model="busData.type" placeholder="请选择部门类型">
              <el-option v-for="item in typeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="部门权限" prop="role_ids">
            <el-select v-model="busData.role_ids" placeholder="请选择部门权限" multiple>
              <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <div style="text-align: center;">
          <el-button size="default" type="primary" @click="editDepartment()">编辑</el-button>
          <el-button size="default" type="warning" @click="deleteDepartment()">删除</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>


export default {
  name: "AddDept",
  components: {},
  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data(){
    return {
      busData: {
        button_id: '',
        parent_name:'',
        name: '',
        type: '',
        role_ids: []
      },
      roleList: [],
      companyList: [],
      rules: {
        name: [
          { required: true, message: '请填写部门名称', trigger: 'change' }
        ]
      }
    }
  },

  computed: {
    typeList() {
      return this.$store.getters['core/getDictList']('sys_department_type');
    },
  },
  created() {
    this.getData();
    this.getRoleList();
    this.getCompanyList();
  },

  methods: {
    async getData() {
      this.busData = this.parentData;
    },

    async addDepartment() {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          let params = this.busData;
          this.$http('sysOrganizationService.addDepartment', params).then(() => {
            this.$message.success("提交成功");
            this.$fn.reloadTreeData();
            this.$fn.closeWindow();
          });
        } else {
          // 表单验证失败，提示用户
          console.log('表单验证失败，请检查输入');
          return false;
        }
      })
    },

    async editDepartment(){
      this.$refs.formData.validate(async valid => {
        if (valid) {
          let params = this.busData;
          this.$http('sysOrganizationService.editDepartment', params).then(() => {
            this.$message.success("提交成功");
            this.$fn.reloadTreeData();
            this.$fn.closeWindow();
          });
        } else {
          // 表单验证失败，提示用户
          console.log('表单验证失败，请检查输入');
          return false;
        }
      })
    },

    async deleteDepartment(){
      let params = this.busData;
      let result = await this.$http('sysOrganizationService.isDeleteDepartment', params);
      if (result){
        this.$confirm('确定删除该部门吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http('sysOrganizationService.deleteDepartment', params).then(() => {
            this.$message.success("删除成功");
            this.$fn.reloadTreeData();
            this.$fn.closeWindow();
          });
        }).catch(() => {
          this.$message({})})
      } else {
        this.$message.error("该部门或子部门下存在未被禁用员工，不可删除");
      }
    },

    async getRoleList() {
      this.roleList = await this.$http('sysOrganizationService.getRoleList')
    },

    async getCompanyList() {
      this.companyList = await this.$http('sysOrganizationService.getCompanyList')
    },

  },

}

</script>

<style scoped>

</style>